import { Injectable } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { AppBarActionsService } from "common";
import { FacilityInfoData, FacilityListData } from "../../feature-modules/facility/domain/models/facility.model";
import { Observable } from "rxjs";
import { AccountService } from "../account.service";
import { AccountData } from "../account.model";

@Injectable()
export class AccountFacilityDetailsFacade {

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly appBarActionsService: AppBarActionsService,
    private readonly accountService: AccountService
  ) {}

  initForm() : UntypedFormGroup {
    return this.formBuilder.group({
      facility: [undefined, Validators.required],
    });
  }

  getAccountData(id: number, uniqueId: string) : Observable<AccountData> {
      return id 
        ? this.accountService.getWithRenewal(id)
        : this.accountService.getByUniqueId(uniqueId);
    }

  patchFormFromFacilityInfo(form: UntypedFormGroup, facilitiesOptions: FacilityListData[], facility: FacilityInfoData): void {
    if (!form || !facility) return;
    form.patchValue({ facility: null });

    const mathingFacility = facilitiesOptions.find(f => f.id == facility.id)
    form.patchValue({
      facility: mathingFacility,
    });
  }

  initAppBarActions() : void {
    this.appBarActionsService.actions = [
      { id: "cancel", label: "Cancel", buttonType: "button" },
      {
        id: "save",
        label: "Save",
        buttonType: "submit",
        buttonAppearance: "flat",
        buttonColor: "primary",
        disabled: true,
      },
    ];
  }

  patchLoanFacility(loanId: number, form: UntypedFormGroup): Observable<void> {
    const facilityId = this.getFacilityIdFromForm(form);
    return this.accountService.updateLoanFacility(loanId, facilityId);
  }

  private getFacilityIdFromForm(form: UntypedFormGroup): number {
    const fullValue = form.getRawValue();

    return fullValue.facility?.id;
  }
}